import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#09090B] text-white pt-16 lg:pt-20 pb-6 relative overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-16 border-b border-white/15">
          <div className="lg:col-span-5">
            <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-[#3FA742]">
              Build your LinkedIn brand
            </p>
            <h3 className="font-display font-extrabold text-3xl sm:text-4xl tracking-tight leading-[1.05] mt-3 max-w-lg">
              New clients are waiting on LinkedIn. Be ready when they look.
            </h3>
            <a
              href="#contact"
              data-testid="footer-cta"
              className="mt-8 inline-flex items-center gap-2 bg-white text-[#09090B] font-bold px-6 py-4 hover:bg-[#3FA742] hover:text-white transition-colors"
            >
              Audit my LinkedIn <ArrowUpRight size={18} />
            </a>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <FooterCol title="Company">
              <FooterLink href="#services">Services</FooterLink>
              <FooterLink href="#how">How it works</FooterLink>
              <FooterLink href="#proof">Case studies</FooterLink>
              <FooterLink href="#pricing">Pricing</FooterLink>
            </FooterCol>
            <FooterCol title="Resources">
              <FooterLink href="#faq">FAQ</FooterLink>
              <FooterLink href="#honest">The honest pitch</FooterLink>
              <FooterLink href="#contact">Free audit</FooterLink>
            </FooterCol>
            <FooterCol title="Contact">
              <FooterLink href="tel:+15106123656" testid="footer-phone">510-612-3656</FooterLink>
              <FooterLink href="mailto:hello@keepsy.co">hello@keepsy.co</FooterLink>
              <FooterLink href="#">LinkedIn</FooterLink>
            </FooterCol>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between gap-6 pt-8">
          <p className="font-mono text-[10px] uppercase tracking-widest text-white/50">
            © {new Date().getFullYear()} Keepsy — Better Leads. More Clients.
          </p>
          <div className="flex gap-6 text-xs font-mono uppercase tracking-widest text-white/50">
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Terms</a>
            <a href="#" className="hover:text-white">Anti-spam</a>
          </div>
        </div>
      </div>

      <div className="mt-8 select-none pointer-events-none leading-none">
        <p className="font-display font-black text-[24vw] tracking-tighter text-white leading-[0.82] -mb-[6vw] text-center">
          KEEPSY
        </p>
      </div>
    </footer>
  );
}

function FooterCol({ title, children }) {
  return (
    <div>
      <p className="font-mono text-[10px] uppercase tracking-widest text-white/50 mb-4">{title}</p>
      <ul className="space-y-3">{children}</ul>
    </div>
  );
}

function FooterLink({ href, children, testid }) {
  return (
    <li>
      <a
        href={href}
        data-testid={testid}
        className="text-sm text-white/85 hover:text-[#3FA742] transition-colors"
      >
        {children}
      </a>
    </li>
  );
}
